import { createElementVNode as _createElementVNode, createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-b62b1a6e"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "w-full min-h-screen flex flex-col" }
const _hoisted_2 = ["src"]
const _hoisted_3 = /*#__PURE__*/_createTextVNode(" Your browser does not support the video tag. ")

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_Card = _resolveComponent("Card")!
  const _component_ScreenWrapper = _resolveComponent("ScreenWrapper")!

  return (_openBlock(), _createElementBlock("section", _hoisted_1, [
    _createVNode(_component_ScreenWrapper, {
      next: _ctx.next,
      screen: _ctx.screen,
      "wrapper-classes": "flex flex-col justify-center"
    }, {
      default: _withCtx(() => [
        _createVNode(_component_Card, { "wrapper-class": "p-2" }, {
          default: _withCtx(() => [
            _createElementVNode("video", {
              ref: "video",
              autoplay: "autoplay",
              class: "w-full",
              controls: "",
              onLoad: _cache[0] || (_cache[0] = 
//@ts-ignore
(...args) => (_ctx.playVideo && _ctx.playVideo(...args)))
            }, [
              _createElementVNode("source", {
                src: _ctx.FILES['video'],
                type: "video/mp4"
              }, null, 8, _hoisted_2),
              _hoisted_3
            ], 544)
          ]),
          _: 1
        })
      ]),
      _: 1
    }, 8, ["next", "screen"])
  ]))
}